export default __webpack_public_path__ + "static/media/notebook.b65c96c5.ogg";